import {html} from 'lit';

export const facet5Template = (isDefault: boolean) => html`
        <div class="image-shapes-5--crop-mobile">
                <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 360 270" xml:space="preserve">
           <path class="fill-violet500-opacity-75" d="M100.1,229.6L76.7,270H30c-22.9,0-37.3-24.8-25.8-44.7l23.4-40.4h46.7C97.2,184.9,111.5,209.8,100.1,229.6z"/>
                        <path class="fill-yellow400" d="M349.6,34.8l-11.1-19C332.9,6.1,322.3,0,310.8,0h-55.2l36.6,63.4H333C347.7,63.3,357,47.4,349.6,34.8z"/>
        </svg>
        </div>
    <div class="image-shapes-5">
        ${isDefault ? html`
            <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 402 370" xml:space="preserve">
                <path class="fill-violet500-opacity-75" d="M126.9,297.2l-24.7,42.7l-49.3,0c-24.2,0-39.4-26.2-27.2-47.2l24.7-42.7l49.3,0
                C123.9,250,139,276.3,126.9,297.2z"/>
                <path class="fill-yellow400" d="M378.3,70.6l-11.7-20.1c-6-10.3-17.2-16.7-29.3-16.7l-58.3,0l38.7,67h43C376.3,100.7,386.1,83.9,378.3,70.6z"/>
                <path class="fill-lightblue400-opacity-75" d="M201.7,33.7l38.7,67l77.3,0l-38.7-67L201.7,33.7z"/>
            </svg>
        ` : html`
            <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 360 280" xml:space="preserve">
                <path class="fill-violet500-opacity-75" d="M298.8,44.4L278.2,80l-41.2,0c-20.2,0-32.9-21.9-22.8-39.4L234.9,5L276,5C296.3,5,308.9,26.9,298.8,44.4z"/>
                <path class="fill-lightblue400-opacity-75" d="M152.8,260.9L119.9,204l-65.6,0l32.8,56.8L152.8,260.9z"/>
                <path class="fill-yellow400" d="M2.7,229.6l9.9,17.1c5.1,8.8,14.6,14.2,24.8,14.2h49.7L54.3,204l-36.7,0C4.3,204-3.9,218.2,2.7,229.6z"/>
            </svg>
        `}
    </div>
`;